/**
 * Contenido compartido para los modales de soporte y donacion.
 * Fuente unica de verdad para backoffice y app movil.
 */

const SUPPORT_LINKS = {
  buyMeACoffee: "https://buymeacoffee.com/Ceaemociones",
  paypal: "https://www.paypal.com/paypalme/ElisaToledoArrom",
};

const SUPPORT_MODAL = {
  emoji: "🎉",
  title: "¡Gracias por jugar!",
  message:
    "Has completado 6 preguntas. Esperamos que estés disfrutando de CEAEmociones y que te esté ayudando en tu aprendizaje emocional.",
  submessage:
    "Si valoras nuestro trabajo y quieres ayudarnos a seguir creando contenido, puedes invitarnos a un café. Tu apoyo nos permite continuar mejorando esta herramienta para todos.",
  supportTitle: "Apoya el proyecto:",
  continueButton: "Continuar",
};

const GAME_TYPE_MODAL = {
  title: "¿Cómo quieres jugar?",
  modalityLabel: "Modalidad:",
  continueButton: "Continuar Partida",
  newGameButton: "Nueva Partida",
  cancelButton: "Cancelar",
};

const MODE_SELECTOR = {
  title: "Selecciona tu modalidad",
  subtitle:
    "Los modos están ordenados por dificultad, siendo el primero el más sencillo y el último el más complicado. ¡Clica uno para empezar, ánimo!",
};

const WELCOME_CONTENT = {
  mainTitle: "CEAEmociones",
  sections: {
    whatIs: {
      title: "💡 Qué es CEAEmociones",
      text: [
        "CEAEmociones es una plataforma interactiva para aprender sobre emociones, interpretar la comunicación no verbal y comprender las intenciones de los demás, entre muchos otros aspectos fundamentales de la interacción social.",
        "Nuestro objetivo es transformar los tradicionales materiales estáticos en una experiencia más realista y atractiva, utilizando vídeos que simulan situaciones sociales auténticas. Así, logramos un aprendizaje más natural, dinámico y cercano a la vida real.",
      ],
    },
    whyProject: {
      title: "🎯 Por qué nace este proyecto",
      intro:
        "Después de años trabajando con manuales convencionales, noté tres grandes necesidades:",
      reasons: [
        {
          label: "Accesibilidad:",
          text: "acercar las herramientas terapéuticas a los hogares, para que cualquier persona —ya sea alguien autista o un familiar— pueda utilizarlas de forma autónoma y sencilla.",
        },
        {
          label: "Motivación:",
          text: "muchos niños y jóvenes CEA se aburrían con los materiales tradicionales. Buscábamos algo más interactivo y visual.",
        },
        {
          label: "Realismo:",
          text: "las interacciones sociales no son imágenes estáticas, por eso era necesario un formato que reflejara la dinámica real de las emociones.",
        },
      ],
    },
    howItWorks: {
      title: "🧭 Cómo funciona",
      text: [
        'Comenzar es muy fácil: solo tienes que hacer clic en "Empezar" y elegir la temática que más te interese.',
        "El acceso es de taquilla inversa, lo que significa que tú decides cuánto aportar según tus posibilidades. Incluso puedes utilizar la plataforma gratuitamente si lo necesitas.",
      ],
      boldTerms: ["taquilla inversa"],
    },
    behindProject: {
      title: "👩🏻‍⚕️👨🏻‍💻 Detrás del proyecto",
      text: [
        "Por un lado está Elisa Toledo Arrom, Psicóloga General Sanitària, Neuropsicóloga Clínica y acreditada en la evaluación diagnóstica de autismo (ADOS-2). Es co-creadora de CEAEmociones, un proyecto nacido de la pasión por acercar las herramientas terapéuticas al día a día de las personas autistas y sus familias.",
        "Este trabajo no habría sido posible sin Salvador Vicens, co-creador e informático, que ha prestado su tiempo y conocimientos para diseñar y hacer realidad la parte técnica de esta plataforma.",
      ],
      boldNames: ["Elisa Toledo Arrom", "Salvador Vicens"],
    },
    support: {
      title: "☕ ¿Quieres apoyarnos?",
      text: [
        "Hemos dedicado más de un año de trabajo e ilusión a este proyecto. Si valoras nuestro trabajo y quieres ayudarnos a seguir creando contenido, puedes invitarnos a un café. Tu apoyo nos permite continuar mejorando esta herramienta para todos.",
      ],
    },
  },
  startButton: "Empezar",
};

module.exports = {
  SUPPORT_LINKS,
  SUPPORT_MODAL,
  GAME_TYPE_MODAL,
  MODE_SELECTOR,
  WELCOME_CONTENT,
};
